import styled, { css } from 'styled-components';

interface NotificationTagProps {
  info?: boolean;
  link?: boolean;
  alert?: boolean;
  success?: boolean;
  secondary?: boolean;
  secondaryBlack?: boolean;
}

const backgroundColor = css<NotificationTagProps>`
  background-color: ${({
    info,
    link,
    alert,
    theme,
    success,
    secondary,
    secondaryBlack,
  }) => {
    if (info) {
      return theme.color.brand01;
    } else if (success) {
      return theme.color.good;
    } else if (alert) {
      return theme.color.badRGBA(0.9);
    } else if (secondaryBlack || secondary || link) {
      return 'transparent';
    } else {
      return theme.color.brand01;
    }
  }};
`;

const NotificationTag = styled('span')<NotificationTagProps>`
  position: relative;
  top: -2px;
  font-size: ${({ theme }) => theme.x1space + 0.2}rem;
  color: white;
  font-weight: 900;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${backgroundColor};
  padding: ${({ theme }) => (theme.x1space - 0.6) * 10}px
    ${({ theme }) => (theme.x1space - 0.4) * 10}px;
`;

export default NotificationTag;
